
import React from 'react'
import { Input, Button, Space, Select, Popover, Tabs } from 'antd';
import Card from '../com/home/card';
import Config from "../../config/Config";
import EventBus from "../../frame/eventBus";
import WidgetAjax from '../../widget/WidgetAjax';

import { checkLogin } from '../../pages/com/utils';
import { CaretDownOutlined } from '@ant-design/icons';
import JobType from './com/JobType';
let path = Config.getBasePath();
let Application = Config.getApplication();
let getCareerUrl = Config.getCareerUrl();
let baseRoutePath = Config.getBaseRoutePath();
class home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      typeFilter: [
        { label: "职位", value: '1' },
        { label: "企业", value: '2' },
      ],
      typeFilterValue: '1',
      jobTypeLoading: true,
      bannerList: [
        { title: "智能简历撰写", icon: require("../../img/pinzhunzhun/dataSource/banner1.png"), onClick: () => this.RedirectTo("career-seek") },
        { title: "精准岗位推荐", icon: require("../../img/pinzhunzhun/dataSource/banner2.png"), onClick: () => this.RedirectTo("career-evaluation") },
        { title: "就业面试辅助", icon: require("../../img/pinzhunzhun/dataSource/banner3.png"), onClick: () => this.jump('PartTimeJob') },
      ],
      screenType: [
        { title: '精选岗位', title_html: <div style={{ display: "flex" }}><div style={{ color: '#3D413E' }}>精选</div>岗位</div>, name: "omnibus_precise", icon: require("../../img/pinzhunzhun/dataSource/precise.png") },
        { title: '精选企业', title_html: <div style={{ display: "flex" }}><div style={{ color: '#3D413E' }}>精选</div>企业</div>, name: "omnibus_entHot", icon: require("../../img/pinzhunzhun/dataSource/entHot.png") }],
      jobData: [],
      TabsData: [],
      TabsValue: undefined,
      hotData: []

    }
  }
  async componentDidMount() {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let userInfo = sessionStorage.getItem("_user_info_");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      let location = JSON.parse(sessionStorage.getItem("_user_location_"));
      await this.setState({ userInfo: userInfo, location });

    }
    if (params) {
      // 获取指定参数的值
      const param1 = params.get('param1');
      const param2 = params.get('param2');
    }
    this.jobTypeList();

    this.entSearch();
    // if (sessionStorage.getItem("_user_access_")) {
    //   this.getUserInfo();
    // }
    EventBus.on('locationChange', this.locationChange);
    this.hotList();
    this.jobaccurate();
  }

  componentWillUnmount() {
    EventBus.off('locationChange', this.locationChange);
  }

  locationChange = async (location) => {
    await this.setState({ location });
    this.hotList();
    this.jobList();
    this.entSearch();
  }

  componentWillReceiveProps() {
    let userInfo = sessionStorage.getItem("_user_info_");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      this.setState({ userInfo: userInfo });
    }
  }

  getUserInfo = () => {
    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({ user: res.result });
      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });
  }

  /**
   * 职位类型
   */
  jobTypeList = async () => {
    await this.setState({ jobTypeLoading: true });
    const onJobTypeList = (res) => {
      if (res.status === 0) {
        if (res.results && res.results.length) {
          let jobTypeData = res.results.filter((item) => item.name !== "常用岗位");
          this.setState({ jobTypeData });
        }
        this.setState({ jobTypeLoading: false });
      }
    };
    WidgetAjax.ajax({
      url: path + '/recruitment/job_type',
      params: { parent_code: "0" },
      callback: onJobTypeList
    });
  }

  /**
   * 热词
   */
  hotList = () => {
    const { location, typeFilterValue } = this.state;
    let params = {
      // type: 'labor',
      // category: '01',
      // search_type: typeFilterValue === '1' ? 'job' : 'enterprise',
      // district: location?.value
      DISTRICT: location?.value,
      type: typeFilterValue === '1' ? 'job' : 'enterprise',
      limit: 6
    }
    const onHotList = (res) => {
      if (res.status == 0) {
        this.setState({ hotData: res.results });
      }
    }
    WidgetAjax.ajax({
      url: path + '/recommend/search_hot',
      params,
      callback: onHotList
    });
  }

  /**
   * 
   * 精选岗位 tabs
   */
  jobaccurate = () => {
    const { location } = this.state;
    let params = {
      type: 'labor',
      district: location?.value,

    }
    const onAccurate = async (res) => {
      if (res.status == 0) {
        let arr = []
        if (res.results && res.results.length > 0) {

          arr = res.results.map((item) => {
            return {
              ...item,
              key: item?.JOBTYPES,
              label: item?.JOBNAME,
            }
          })
        }

        await this.setState({ TabsData: arr, TabsValue: arr[0]?.key });
      }
      this.jobList();
    }
    WidgetAjax.ajax({
      url: path + '/recommend/job_type',
      params,
      callback: onAccurate
    });
  }




  /**
   * 岗位
   * @param {*} value 
   * @param {*} callback 
   */
  jobList = (value, callback) => {
    const { location, TabsValue } = this.state;
    let params = {
      JOBCATEGORY:"1",
      type: 'labor',
      category: '01',
      query: "*",
    }
    if (value) {
      params = {
        ...params,
        page: 1, records: 3,
          
        enterprise_id: value
      }
    } else {
      params = {
        ...params,
        page: 1, records: 9,
        DISTRICT: location ? [location?.value] : undefined,
        JOBTYPE: TabsValue ? TabsValue : undefined,
      }
    }
    const onJobList = (res) => {
      if (res.status == 0) {
        if (!callback) {
          this.setState({ jobData: res.results });
        }

        if (typeof callback === 'function') {
          callback(res.results);
        }
      }
    }
    let url = '/job/search' 
    // if (value) url = '/job/search' '/recommend/job_list'
    WidgetAjax.ajax({ url: path + url, params, callback: onJobList });
  }



  /**
   * 企业
   */
  entSearch = () => {
    const { location } = this.state;
    const onEntSearch = (res) => {
      if (res.status == 0) {
        if (res.results && res.results.length > 0) {
          let entData = res.results.map((item) => {
            return { ...item, job_load: true, job_data: [] }
          })
          this.setState({ entData });

          entData.forEach((item) => {
            const onData = (res) => {
              const newItem = { ...item, job_load: false, job_data: res };
              this.setState((prevState) => {
                const newEntData = prevState.entData.map((oldItem) => {
                  if (oldItem.id === newItem.id) {
                    return newItem;
                  }
                  return oldItem;
                });
                return {
                  entData: newEntData
                };
              });
            };
            this.jobList(item.id, onData);
          });
        } else {
          this.setState({ entData: [] })
        }
      }
    }
    WidgetAjax.ajax({
      url: path + '/recommend/enterprise_list',
      params: {
        type: 'labor',
        category: '01',
        district: location ? [location?.value] : undefined,
        page: 1,
        records: 9
      },
      callback: onEntSearch
    });
  }

  // aiChat = (type) => {
  //   if (checkLogin()) {
  //     this.props.history.push({ pathname: "/home/ai-chat", state: { scene: type } });
  //   }
  //   else {
  //     this.logOut("/home/ai-chat", { scene: type });
  //   }
  // }

  logOut = (URL, state) => {
    this.props.history.push({ pathname: URL ? '/login?redirectURL=' + URL : "/login", state });
    window.location.reload();

  }

  tabsChange = async (value) => {
  
    await this.setState({ TabsValue: value });
    this.jobList();
  }

  screenType = (obj) => {
    const { jobData, entData, TabsData, TabsValue } = this.state;
    let children = <div className='tabs_box'>
      <Tabs items={TabsData} onChange={this.tabsChange} value={TabsValue} />
    </div>
    switch (obj?.title) {
      case "精选岗位":
        return <>
          <Card obj={obj} data={jobData} type={'job'} history={this.props.history} children={children} />
        </>
      case "精选企业":
        return <Card obj={obj} data={entData} type={'ent'} history={this.props.history} />

      default:
        return "暂无"
    }
  }

  tagRedirect = () => {
    const currentUrl = window.location.href;
    const homeIndex = currentUrl.indexOf('home/');
    if (homeIndex !== -1) {
      let newUrl = currentUrl.substring(0, homeIndex + 'home/'.length);
      const params = new URLSearchParams();
      newUrl = newUrl + 'profession'
      let urlWithParams = `${newUrl}?${params.toString()}`;
      window.open(urlWithParams, '_blank');
    }
  }

  toSearch = () => {
  const { searchValue, typeFilterValue } = this.state;
  const currentUrl = window.location.href;
  const homeIndex = currentUrl.indexOf('home/');
  let baseHomeUrl = '';

  // 分支1：当前页面包含 home/ 路径，截取原有前缀
  if (homeIndex !== -1) {
    baseHomeUrl = currentUrl.substring(0, homeIndex + 'home/'.length);
  } else {
    // 分支2：首页无home，自动拼接域名+项目根目录+home/
    const origin = window.location.origin;
    // 修复：baseRoutePath 已以 "/" 开头，origin 不带末尾斜杠，二者直接拼接即可，不能再加 "/"
    baseHomeUrl = `${origin}${baseRoutePath}/home/`;
  }

  const params = new URLSearchParams();
  if (searchValue) params.append('word', searchValue);

  // 匹配页面后缀
  let pagePath = '';
  switch (typeFilterValue) {
    case "1":
      pagePath = 'recommendedJob';
      break;
    case "2":
      pagePath = 'enterprise';
      break;
    default:
      // 筛选值为空时默认岗位页，可自行修改
      pagePath = 'recommendedJob';
  }

  // 拼接参数，无参数不显示?
  const query = params.toString() ? `?${params.toString()}` : '';
  const targetUrl = `${baseHomeUrl}${pagePath}${query}`;

  window.open(targetUrl, '_blank');
};



  jump = (url) => {
    const currentUrl = window.location.href;

    const homeIndex = currentUrl.indexOf('home/');
    let newUrl;
    if (homeIndex != -1) {
      newUrl = currentUrl.substring(0, homeIndex + 'home/'.length);
    } else {
      // 修复：复用 toSearch 的拼接方式，避免 currentUrl 末尾 "/" + "/home/" 出现双斜杠
      const origin = window.location.origin;
      newUrl = `${origin}${baseRoutePath}/home/`;
    }
    window.open(`${newUrl}` + url, '_blank');

  }

  RedirectTo = (link) => {
    const accessToken = sessionStorage.getItem('_user_access_');
    if(!accessToken) return window.open(`${getCareerUrl}/login`, '_blank');;
    const encodedToken = btoa(accessToken);
    const signature = btoa(accessToken + Application);
    window.open(`${getCareerUrl}/tokenLogin?token=${encodedToken}&sig=${signature}&link=${link}`, '_blank');
  }



  notify = (tab) => {
    if (checkLogin()) {
      if (tab === '5') {
        this.props.history.push({ pathname: "/home/resume" });
      } else if (tab === '6') {
      } else {
        this.props.history.push({ pathname: "/home/applicant", state: { tab } });
      }
    } else {
      let url;
      let state;
      switch (tab) {
        case "5":
          url = "/home/resume";
          break;
        case "6":
          break;
        default:
          url = "/home/applicant";
          state = { tab };
          break;
      }

      this.logOut(url, state);
    }
  }
  profession = (type) => {
    this.props.history.push({
      pathname: "/home/profession/detail",
      state: { name: type }
    });
  }

  setWork = async (value) => {
    await this.setState({ searchValue: value });
    this.toSearch()
  }

  onType = async (value) => {
    await this.setState({ typeFilterValue: value });
    this.hotList()
  }

  render() {
    const { typeFilter, typeFilterValue, jobTypeData, bannerList, screenType, jobTypeLoading, hotData } = this.state;

    return <div component-data="home">
      <div className='screen'>
        <div className='head_filter'>
          <div className='box_1200 '>
            <div className='head_filter_box'>
              <img className='home_logo' src={require("../../img/pinzhunzhun/dataSource/logo.svg")} />
              <div className='search_home'>
                <div className='search_box'>
                  <Space.Compact style={{ width: '100%' }}>
                    <Select defaultValue="岗位" options={typeFilter} value={typeFilterValue} onChange={(value) => this.onType(value)} dropdownStyle={{ width: "86px" }} suffixIcon={<CaretDownOutlined />} />
                    <Input placeholder="搜索关键词" onChange={(e) => { this.setState({ searchValue: e.target.value }) }} />
                    <Button type="primary" onClick={() => { this.toSearch() }} >搜索</Button>
                  </Space.Compact>
                  <img className='ai_recommendation'
                    onClick={() => { this.aiChat("岗位推荐") }}
                    src={require("../../img/pinzhunzhun/dataSource/ai_recommendation.png")} />
                </div>
                <div className='hot_jobType'>
                  <label> 热门搜索: </label>
                  {
                    hotData && hotData.map((item) => {
                      return <div className='hot_item' onClick={() => this.setWork(item.word)}> {item.word}</div>
                    })
                  }
                </div>
              </div>
              <div className='board_qrCode' >
                {/* <Popover placement="right" content={<img className='codeImg' src={require("../../img/pinzhunzhun/dataSource/public_code.png")} />}>
                  <a>扫码进公众号</a>
                </Popover> */}
                {/* <Popover placement="right" content={<img  className='codeImg'src={require("../../img/pinzhunzhun/dataSource/applet.png")} />}>
                  <a>扫码进求职招聘小程序</a>
                </Popover> */}
              </div>
            </div>
          </div>
        </div>

        <div className='box_1200 ' style={{ paddingTop: '150px' }}>

          <div className='box_banner'>

            <JobType data={jobTypeData} loading={jobTypeLoading} options={{ records: 10 }} history={this.props?.history} />
            <div className='job_banner'>
              <div className='template1'>
                <img className='template1_01' onClick={() => this.RedirectTo("career-planning")} src={require("../../img/pinzhunzhun/dataSource/banner_01.png")} />
                <div>
                  {
                    bannerList.map((item, index) => {
                      return <div onClick={item?.onClick}>
                        <img className='template1_02' src={item?.icon} />
                      </div>
                    })
                  }
                </div>
              </div>
              <div className='template2' onClick={() => this.jump('enterprise')}>
                <img className='template' src={require("../../img/pinzhunzhun/dataSource/banner_02.png")} />
                {/* <img className='template' src={require("../../img/pinzhunzhun/dataSource/banner_03.png")} /> */}
              </div>
            </div>
          </div>
          <div className='omnibus'>
            {
              screenType.map((item) => {
                return this.screenType(item);
              })
            }
          </div>

        </div>
      </div>
    </div>
  }
}

export default home;